import { EFinancingCompany } from '@if/core/types'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useSelectedCompany, useSetSelectedCompany } from '@src/providers/SelectedCompanyProvider'
import { useUser } from '@src/providers/UserProvider'

const CompanySelector = () => {
  const user = useUser()
  const selectedCompany = useSelectedCompany()
  const availableCompanies = user?.companyIds || []
  const setCompany = useSetSelectedCompany()

  const showCompanySelector =
    availableCompanies.includes(EFinancingCompany.IFinance) && availableCompanies.includes(EFinancingCompany.Iceberg)

  const handleChange = (event: SelectChangeEvent<EFinancingCompany>) => {
    const company = event.target.value as EFinancingCompany
    setCompany(company)
  }

  if (!showCompanySelector || availableCompanies.length === 0) {
    return null
  }

  return (
    <Select fullWidth={false} value={selectedCompany ?? ''} onChange={handleChange}>
      {availableCompanies.map((company) => (
        <MenuItem key={company} value={company}>
          {company}
        </MenuItem>
      ))}
    </Select>
  )
}

export default CompanySelector
